import type { ReactNode, SVGProps } from "react";

export function ChatIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="24"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				clipRule="evenodd"
				d="M12 3C6.75329 3 2.5 6.90812 2.5 11.7297C2.5 14.3539 3.76073 16.7059 5.75342 18.3023C5.87962 18.4034 5.95313 18.5563 5.95313 18.718V21.4512C5.95313 21.8382 6.37388 22.0788 6.70759 21.8828L9.53783 20.2207C9.66187 20.1479 9.80934 20.126 9.94875 20.1601C10.6042 20.3204 11.2919 20.4059 12 20.4059C17.2467 20.4059 21.5 16.4978 21.5 11.6762C21.5 6.85466 17.2467 3 12 3Z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	);
}
